import { render, staticRenderFns } from "./ArrayItemsEditDialog.vue?vue&type=template&id=d4b1ce94&"
import script from "./ArrayItemsEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ArrayItemsEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports